import { render, staticRenderFns } from "./about-us.component.vue?vue&type=template&id=1df88a46"
import script from "./about-us.component.ts?vue&type=script&lang=ts&external"
export * from "./about-us.component.ts?vue&type=script&lang=ts&external"
import style0 from "./about-us.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports